









import { Component, Vue, Watch } from 'vue-property-decorator';
import { ErrorStore } from '@/stores/error.store';
import { getModule } from 'vuex-module-decorators';
import { StandardError } from '@/util/StandardErrors';

@Component
export default class ErrorDisplay extends Vue {
  private errorHandler = getModule(ErrorStore, this.$store);

  get i18nKey(): string {
    if (this.currentError) {
      return 'message.error.' + this.currentError.errorKey;
    }
    return '';
  }

  @Watch('currentError')
  public async onCurrentErrorChange() {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  private get currentError(): StandardError | null {
    return this.errorHandler.currentError;
  }

  public dismissError() {
    this.errorHandler.dismissError();
  }
}
